// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditMode_editMode__H2UhC {
  width: 100%;
  position: fixed;
  background-color: var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  padding: 1rem 2rem;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
}
.EditMode_editMode__H2UhC > :first-child, .EditMode_editMode__H2UhC > :nth-child(2) {
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.EditMode_editMode__button__Ist0a {
  background-color: var(--color-table-grey-1);
  padding: 1rem 2rem;
  border-radius: 8px;
  display: flex;
  gap: 1rem;
  align-items: center;
}
.EditMode_editMode__button__Ist0a:hover {
  color: var(--color-primary);
  background-color: var(--color-table-grey);
}

.EditMode_pages__tmDOd {
  position: relative;
  color: var(--color-dark);
  min-width: 20rem;
}
.EditMode_pages__selected__e61u3 {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background-color: var(--color-white);
  padding: 1rem;
  border-radius: 8px;
}
.EditMode_pages__drop__2vZ3L {
  position: absolute;
  top: 5rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-white);
  min-width: 20rem;
  max-height: 27rem;
  overflow-y: auto;
  max-width: 38rem;
  box-sizing: border-box;
}
.EditMode_pages__drop__2vZ3L > :first-child:hover {
  border-radius: 8px 8px 0 0;
}
.EditMode_pages__drop__2vZ3L > :last-child:hover {
  border-radius: 0 0 8px 8px;
}
.EditMode_pages__drop__2vZ3L > :not(:last-child) {
  border-bottom: 1px solid #ddd;
}
.EditMode_pages__drop__item__gWA\\+B {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  align-items: center;
}
.EditMode_pages__drop__item__gWA\\+B:hover {
  background-color: var(--color-grey-3);
  font-weight: 700;
}

.EditMode_sections__lh6pt {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 40rem;
  background-color: var(--color-grey-3);
  border-radius: 1rem;
  padding: 2rem;
}

.EditMode_section__btn__9bPki {
  background-color: var(--color-white);
  border-radius: 1rem;
  padding: 1.5rem 2rem;
  width: 100%;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
}
.EditMode_section__btn__active__3EGSF {
  background-color: var(--color-green-3);
}
.EditMode_section__btn__active2__ocM62 {
  background-color: var(--color-primary-9);
}
.EditMode_section__arr__71eO- {
  font-size: 3rem;
  transition: all 500ms ease-in-out;
}
.EditMode_section__arr__active__9mNIS {
  transform: rotateZ(180deg);
  color: var(--color-green);
}
.EditMode_section__expanded__3ih0M {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  background-color: var(--color-white);
  border-radius: 1rem;
  padding: 1.5rem 2rem;
  margin-top: 1rem;
}
.EditMode_section__flex__pz8eI {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}
.EditMode_section__array__6IbDs {
  border: 1px dashed var(--color-primary);
  padding: 1rem;
  border-radius: 1rem;
  margin-bottom: 1rem;
}
.EditMode_section__array__container__YXwar {
  margin-top: 1rem;
}
.EditMode_section__array__sb__bKPq4 {
  display: flex;
  justify-content: space-between;
}
.EditMode_section__array__remove__DIZXo {
  color: var(--color-white);
  font-size: 2.5rem;
  cursor: pointer;
  background-color: var(--color-error);
  border: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 4px;
}
.EditMode_section__array__remove__DIZXo span {
  font-size: 1.4rem;
  font-weight: 700;
}
.EditMode_section__array__remove__DIZXo:hover {
  background-color: var(--color-deep-red);
}
.EditMode_section__array__add__70tzV {
  color: var(--color-white);
  font-size: 1.4rem;
  cursor: pointer;
  background-color: var(--color-green);
  border: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: 4px;
  font-weight: 700;
}
.EditMode_section__array__add__70tzV:hover {
  background-color: var(--color-success);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/EditMode/EditMode.module.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,eAAA;EACA,mCAAA;EACA,4CAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AADJ;AAGI;EAEI,aAAA;EACA,uBAAA;EACA,SAAA;AAFR;AAKI;EACI,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAHR;AAKQ;EACI,2BAAA;EACA,yCAAA;AAHZ;;AAQA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;AALJ;AAOI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;AALR;AAQI;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,4CAAA;EACA,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AANR;AAUY;EACI,0BAAA;AARhB;AAaY;EACI,0BAAA;AAXhB;AAeQ;EACI,6BAAA;AAbZ;AAgBQ;EACI,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAdZ;AAiBY;EACI,qCAAA;EAEA,gBAAA;AAhBhB;;AAsBA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;AAnBJ;;AAuBI;EACI,oCAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AApBR;AAsBQ;EACI,sCAAA;AApBZ;AAuBQ;EACI,wCAAA;AArBZ;AAyBI;EACI,eAAA;EACA,iCAAA;AAvBR;AAyBQ;EACI,0BAAA;EACA,yBAAA;AAvBZ;AA2BI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAzBR;AA4BI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AA1BR;AA6BI;EACI,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AA3BR;AA6BQ;EACI,gBAAA;AA3BZ;AA8BQ;EACI,aAAA;EACA,8BAAA;AA5BZ;AA+BQ;EACI,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AA7BZ;AA+BY;EACI,iBAAA;EACA,gBAAA;AA7BhB;AAgCY;EACI,uCAAA;AA9BhB;AAkCQ;EACI,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAhCZ;AAkCY;EACI,sCAAA;AAhChB","sourcesContent":["@import '../variables/breakpoints';\n\n.editMode {\n    width: 100%;\n    position: fixed;\n    background-color: var(--color-dark);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    padding: 1rem 2rem;\n    top: 0;\n    left: 0;\n    z-index: 1001;\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n    flex-wrap: wrap;\n    align-items: center;\n\n    &> :first-child,\n    &> :nth-child(2) {\n        display: flex;\n        justify-content: center;\n        gap: 1rem;\n    }\n\n    &__button {\n        background-color: var(--color-table-grey-1);\n        padding: 1rem 2rem;\n        border-radius: 8px;\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n\n        &:hover {\n            color: var(--color-primary);\n            background-color: var(--color-table-grey);\n        }\n    }\n}\n\n.pages {\n    position: relative;\n    color: var(--color-dark);\n    min-width: 20rem;\n\n    &__selected {\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n        justify-content: space-between;\n        cursor: pointer;\n        background-color: var(--color-white);\n        padding: 1rem;\n        border-radius: 8px;\n    }\n\n    &__drop {\n        position: absolute;\n        top: 5rem;\n        border-radius: 8px;\n        display: flex;\n        flex-direction: column;\n        cursor: pointer;\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n        background-color: var(--color-white);\n        min-width: 20rem;\n        max-height: 27rem;\n        overflow-y: auto;\n        max-width: 38rem;\n        box-sizing: border-box;\n\n\n        &> :first-child {\n            &:hover {\n                border-radius: 8px 8px 0 0;\n            }\n        }\n\n        &> :last-child {\n            &:hover {\n                border-radius: 0 0 8px 8px;\n            }\n        }\n\n        &> :not(:last-child) {\n            border-bottom: 1px solid #ddd;\n        }\n\n        &__item {\n            display: flex;\n            gap: 1rem;\n            padding: 1rem;\n            align-items: center;\n\n\n            &:hover {\n                background-color: var(--color-grey-3);\n                // color: var(--color-white);\n                font-weight: 700;\n            }\n        }\n    }\n}\n\n.sections {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    width: 40rem;\n    background-color: var(--color-grey-3);\n    border-radius: 1rem;\n    padding: 2rem;\n}\n\n.section {\n    &__btn {\n        background-color: var(--color-white);\n        border-radius: 1rem;\n        padding: 1.5rem 2rem;\n        width: 100%;\n        font-weight: 700;\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        justify-content: space-between;\n\n        &__active {\n            background-color: var(--color-green-3);\n        }\n\n        &__active2 {\n            background-color: var(--color-primary-9);\n        }\n    }\n\n    &__arr {\n        font-size: 3rem;\n        transition: all 500ms ease-in-out;\n\n        &__active {\n            transform: rotateZ(180deg);\n            color: var(--color-green);\n        }\n    }\n\n    &__expanded {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        width: 100%;\n        background-color: var(--color-white);\n        border-radius: 1rem;\n        padding: 1.5rem 2rem;\n        margin-top: 1rem;\n    }\n\n    &__flex {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 1rem;\n    }\n\n    &__array {\n        border: 1px dashed var(--color-primary);\n        padding: 1rem;\n        border-radius: 1rem;\n        margin-bottom: 1rem;\n\n        &__container {\n            margin-top: 1rem;\n        }\n\n        &__sb {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        &__remove {\n            color: var(--color-white);\n            font-size: 2.5rem;\n            cursor: pointer;\n            background-color: var(--color-error);\n            border: none;\n            display: flex;\n            align-items: center;\n            gap: 1rem;\n            padding: 0.5rem;\n            border-radius: 4px;\n\n            span {\n                font-size: 1.4rem;\n                font-weight: 700;\n            }\n\n            &:hover {\n                background-color: var(--color-deep-red);\n            }\n        }\n\n        &__add {\n            color: var(--color-white);\n            font-size: 1.4rem;\n            cursor: pointer;\n            background-color: var(--color-green);\n            border: none;\n            display: flex;\n            align-items: center;\n            gap: 1rem;\n            padding: 1rem;\n            border-radius: 4px;\n            font-weight: 700;\n\n            &:hover {\n                background-color: var(--color-success);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editMode": `EditMode_editMode__H2UhC`,
	"editMode__button": `EditMode_editMode__button__Ist0a`,
	"pages": `EditMode_pages__tmDOd`,
	"pages__selected": `EditMode_pages__selected__e61u3`,
	"pages__drop": `EditMode_pages__drop__2vZ3L`,
	"pages__drop__item": `EditMode_pages__drop__item__gWA+B`,
	"sections": `EditMode_sections__lh6pt`,
	"section__btn": `EditMode_section__btn__9bPki`,
	"section__btn__active": `EditMode_section__btn__active__3EGSF`,
	"section__btn__active2": `EditMode_section__btn__active2__ocM62`,
	"section__arr": `EditMode_section__arr__71eO-`,
	"section__arr__active": `EditMode_section__arr__active__9mNIS`,
	"section__expanded": `EditMode_section__expanded__3ih0M`,
	"section__flex": `EditMode_section__flex__pz8eI`,
	"section__array": `EditMode_section__array__6IbDs`,
	"section__array__container": `EditMode_section__array__container__YXwar`,
	"section__array__sb": `EditMode_section__array__sb__bKPq4`,
	"section__array__remove": `EditMode_section__array__remove__DIZXo`,
	"section__array__add": `EditMode_section__array__add__70tzV`
};
export default ___CSS_LOADER_EXPORT___;
